export const workFlash = {
  /** Time each image stays on screen (ms) */
  interval: 1000,
  images: [
    {
      src: 'https://cdn.magicpatterns.com/uploads/51gKnGbHjoppXbP7sH43qb/cf1caea78ff3b88d4b48b3df65050007.jpg',
      alt: 'AstraMail billboard on a large stage screen',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/ueWVpUdUcYchSoytM4rV8k/887a4e3b9d445f3af7d986c4a493a223.jpg',
      alt: 'Man holding out a phone showing the Dynamic Scenes app',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/nf5DWqqXVqyHknJFT83Kpr/1d0879a4defe6b0dc03d68099322fe45.jpg',
      alt: 'Tablet showing the Onspace AR glasses website',
    },
    {
      src: 'https://cdn.magicpatterns.com/uploads/g9vYSesjqEHHzed8MsNSqm/46a9b83ddc28b0d81e1ce991680ba293.jpg',
      alt: 'Lime keyboard key reading Coming Soon among dark keycaps',
    },
  ],
};
